import { useCallback, useContext } from 'react';
import { Dispatch } from 'redux';
import ReduxContext from 'src/contexts/ReduxContext';
import { ITmdState } from 'src/reducers';



export const useActionCreator = <T extends (...args: any) => any>(actionCreator: T, dispatch: Dispatch<ITmdState>) => {
    return useCallback((...args: Parameters<T>) => {
        dispatch(actionCreator(...args));
    }, [actionCreator, dispatch]);
}

const useDispatch = () => {
    const context = useContext(ReduxContext);

    return context.dispatch;
}

export default useDispatch;